import ApiResourceManager from '../ApiResourceManager';

/**
 * Partner self-service settings — always acts on the signed-in partner
 * admin's own service provider (the backend pins non-privileged users to it),
 * so unlike the SuperAdmin managers there is no on-behalf override.
 */
export default class PartnerSettingsManager extends ApiResourceManager {
  getProfile = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/profile',
    });

  updateProfile = (data) =>
    this.request({
      method: 'PUT',
      url: '/partner-settings/profile',
      data,
    });

  /**
   * Who processes the partner's payments — FoodAmigos via Adyen, or the
   * partner's own providers. Chosen once; changing it later goes through
   * `switchProcessorMode`, which the backend refuses while a restaurant is
   * live on the current choice.
   */
  getProcessorMode = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/payments/mode',
    });

  chooseProcessorMode = (mode) =>
    this.request({
      method: 'PUT',
      url: '/partner-settings/payments/mode',
      data: { mode },
    });

  switchProcessorMode = (mode) =>
    this.request({
      method: 'POST',
      url: '/partner-settings/payments/mode/switch',
      data: { mode },
    });

  /**
   * The partner's service-fee defaults, platform caps, the recommended setting
   * and the partner's revenue share — what the partner-portal calculator runs on.
   */
  getServiceFee = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/service-fee',
    });

  getBrand = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/brand',
    });

  updateBrand = (data) =>
    this.request({
      method: 'PUT',
      url: '/partner-settings/brand',
      data,
    });

  uploadLogo = ({ type, file }) => {
    const data = new FormData();
    data.append('type', type);
    data.append('file', file);

    return this.request({
      method: 'POST',
      url: '/partner-settings/brand/logo',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  deleteLogo = (type) =>
    this.request({
      method: 'DELETE',
      url: '/partner-settings/brand/logo',
      data: { type },
    });
}
